import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Add meta tags for performance
const metaViewport = document.createElement('meta');
metaViewport.name = 'viewport';
metaViewport.content = 'width=device-width, initial-scale=1';
document.head.appendChild(metaViewport);
const metaThemeColor = document.createElement('meta');
metaThemeColor.name = 'theme-color';
metaThemeColor.content = '#1a1a1a';
document.head.appendChild(metaThemeColor)
// Meta Pixel Code
;
(function (f, b, e, v, n, t, s) {
  if (f.fbq) return;
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!f._fbq) f._fbq = n;
  n.push = n;
  n.loaded = !0;
  n.version = '2.0';
  n.queue = [];
  t = b.createElement(e);
  t.async = !0;
  t.src = v;
  s = b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t, s);
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
window.fbq('init', '1495545045541881');
window.fbq('track', 'PageView');
// Add noscript fallback
const noscript = document.createElement('noscript');
const img = document.createElement('img');
img.height = 1;
img.width = 1;
img.style.display = 'none';
img.src = 'https://www.facebook.com/tr?id=1495545045541881&ev=PageView&noscript=1';
noscript.appendChild(img);
document.body.appendChild(noscript);
render(<App data-id="element-291" />, document.getElementById('root'));